import { useQuery } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { isValidCustomerId } from '../../../customers';
import { getL3ServiceLocations } from '../../api';
import { L3ServiceLocationsHttpQuery } from '../../config';
import { L3ServiceLocationViewModel, mapL3ServiceLocationApiToViewModel } from '../../model';

export interface L3ServiceLocationsApiGetHookResult {
  locations: L3ServiceLocationViewModel[] | null;
  isFetching: boolean;
  isFetched: boolean;
}

export const useL3ServiceLocationsApiGet = (customerId: number | null | undefined): L3ServiceLocationsApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const { data, isFetching, isFetched } = useQuery({
    queryKey: [L3ServiceLocationsHttpQuery['GetL3ServiceLocations'].key, customerId],
    queryFn: async () => {
      if (customerId === null || customerId === undefined) {
        return null;
      } else {
        const apiL3ServiceLocations = await getL3ServiceLocations(axios, { customerId });
        return mapL3ServiceLocationApiToViewModel(apiL3ServiceLocations);
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false,
  });
  return {
    locations: data === undefined ? null : data,
    isFetching,
    isFetched
  };
};